'use client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { PropsWithChildren } from 'react'
import ApiContext from '../context/ApiContext'

const queryClient = new QueryClient()

export function QueryProviders({ children, apiUrl }: PropsWithChildren<{ apiUrl: string }>) {
	return (
		<QueryClientProvider client={queryClient}>
			<ApiContext.Provider value={{ apiUrl }}>{children}</ApiContext.Provider>
		</QueryClientProvider>
	)
}
